// extracted by mini-css-extract-plugin
module.exports = {"youtube-video":"styles__youtube-video__pmlsw","youtubeVideo":"styles__youtube-video__pmlsw","wrapper":"styles__wrapper__2b1Hd"};